import script from "./MensajeFlotante.vue?vue&type=script&setup=true&lang=ts"
export * from "./MensajeFlotante.vue?vue&type=script&setup=true&lang=ts"

import "./MensajeFlotante.vue?vue&type=style&index=0&id=79ccb480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ccb480"]])

export default __exports__